
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import TipoFotoAtlas from '@/model/resource/TipoFotoAtlas'

export default (model: TipoFotoAtlas): Schema => ({
  idTipoFotoAtlas: {
    content: model.idTipoFotoAtlasPk,
    editable: false,
  },

  descricao: {
    content: model.descricao,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  ehObrigatorio: {
    content: bool(model.obrigatorio),
    editable: false,
  },
})
